export class ArgumentError extends Error {
    constructor(message: string, public paramName: string, error?: Error) {
        super(ArgumentError.buildMessage(message, paramName, error));
        this.name = 'ArgumentError';
    }

    private static buildMessage(message: string, paramName: string, error?: Error) {
        return `${message} (Parameter '${paramName}')`;
    }
}